import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();

    useEffect(() => {}, []);

    useEffect(() => {
        scrollTop();
    }, [pathname]);

    const scrollTop = () => {
        window.scrollTo(0, 0);
    };

    return (
        <footer className="footer-wrapper">
            <div className="inner">
                <h2 className="ft_logo">aw</h2>
                <dl className="ft_dl">
                    <dt>Address</dt>
                    <dd>
                        <address>
                            (61003) <br />
                            {t("광주광역시 북구 추암로 249")} <br />({t("광주테크노파크 치매기술실증센터 209호")})
                        </address>
                    </dd>
                </dl>
                <dl className="ft_dl">
                    <dt>Contact</dt>
                    <dd>
                        <a href="tel:0623723731">{t("T. 062 . 372 . 3731")}</a>
                        <a href="tel:0623723735">{t("F. 062 . 372 . 3735")}</a>
                        <a href="mailto:office@autowells.co.kr">{t("E. office@autowells.co.kr")}</a>
                    </dd>
                </dl>

                <div className="ft_cont">
                    <p>Copyright 2020. AUTOWELLS CO.,LTD. All rights reserved.</p>
                    <p>
                        <Link to="/policy">{t("개인정보처리방침")}</Link>
                    </p>
                </div>
                <a href="javascript:;" className="btn_scrollTop" onClick={scrollTop}>
                    {t("위로가기")}
                </a>
            </div>
        </footer>
    );
};

export default Footer;
